// extracted by mini-css-extract-plugin
module.exports = {"partnershipReportContainer":"Report_partnershipReportContainer__1jGR_"};